import { Box, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const leftTriangleColor = "#7FFF00"
const rightTriangleColor = "#66CDAA"


function CellularEnergy() {






    return (
        <Box sx={{ position: 'relative' }} pt={4} >
            <Box sx={{ position: 'relative', marginInline: 'auto' }} width={55} height={230} >
                <StyledLeftTriangle />
                <StyledRightTriangle />
            </Box>

            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={1} mt={2} flexWrap={'wrap'}>
                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={1} flex={1}>
                    <StyledDot color={rightTriangleColor} />
                    <Typography
                        sx={{ whiteSpace: 'nowrap' }}
                        variant='caption'>{t('celular:aero')}</Typography>
                </Box>
                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={1} flex={1}>
                    <StyledDot color={leftTriangleColor} />
                    <Typography sx={{ whiteSpace: 'nowrap' }}
                        variant='caption'>{t('celular:anaero')}</Typography>
                </Box>
            </Box>

        </Box>
    )
}


const StyledLeftTriangle = styled.div`
clip-path: polygon(0 0, 0% 100%, 100% 0);
width:100%;
height:100%;
background-color:${leftTriangleColor};
border-radius:5px;
`
const StyledRightTriangle = styled.div`
clip-path: polygon(100% 100%, 0% 100%, 100% 0);
width:100%;
height:100%;
background-color:${rightTriangleColor};
position:absolute;
top:0;
right:-3px;
border-radius:5px;
`

const StyledDot = styled.div<{ color: string; }>`
width:12px;
height:12px;
border-radius:50%;
background-color:${props => props.color}
`

export default CellularEnergy